<span class="delta-wrapper" *ngIf="isNumber">
  <i [ngClass]="deltaClass"></i>
  <span [ngClass]="deltaTextClass">
    {{ _delta }}<span *ngIf="showPercentage">%</span>
  </span>
</span>
